import { z } from 'zod';

import { LanguageEnum } from '../../enums';
import { languageEnumValidator } from '../../validators';

export const TranslateSchema = z.object({
  language: languageEnumValidator.optional().default(LanguageEnum.RU),
  text: z.string().min(1, 'Text cannot be empty'),
});

export type ITranslateDto = z.infer<typeof TranslateSchema>;
